import api from './api'
import { useDownload } from '@/helpers/download'

export default {  
    
    count(params = {}) {

        return api.get('/devis', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },  

    get(id) {

        return api.get('/devis/' + id, { cache: false })
            .then( json => {

                let devis = json.data
                return devis
            })
            
    },

    getDocuments(id, ligneNums) {

        return new Promise((resolve, reject) => {

            api.post('/devis/' + id + '/documents/file', { lignes: ligneNums })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun document à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },

    getFile(id) {
        
        return new Promise((resolve, reject) => {

            api.post('/devis/' + id + '/file', {})
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun document à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
            })
            
    },

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/devis/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },

    list(params = {}) {

        return api.get('/devis', { params })
            .then( json => json.data )
            
    },

    retrieve(id) {

        return api.get('/devis/' + id + '/retrieve',  { cache: false })
            .then( json => {
                let devis = json.data
                return devis 
            })
            
    },    

    search(params = {}) {

        return api.get('/devis', { params })
            .then( json => json.data )            
    } 
}
